import { EventEmitter, ɵɵdirectiveInject, ɵɵdefineComponent, ɵɵNgOnChangesFeature, ɵsetClassMetadata, Component, Inject, Input, Output, ɵɵelement, ɵɵnextContext, ɵɵproperty, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, ɵɵelementContainerStart, ɵɵtemplate, ɵɵelementContainerEnd, ɵɵadvance, ɵɵlistener, ɵɵtextInterpolate, ɵɵgetCurrentView, ɵɵrestoreView, ɵɵsanitizeUrl, ɵɵpropertyInterpolate, ɵɵpropertyInterpolate1, ɵɵclassMap, ɵɵstaticViewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ɵɵInheritDefinitionFeature, ɵɵattribute, ViewChild, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import 'ol/ol.css';
import Map from 'ol/Map';
import ol_View from 'ol/View';
import MousePosition from 'ol/control/MousePosition';
import { createStringXY } from 'ol/coordinate';
import { ZoomSlider, ScaleLine } from 'ol/control';
import { getWidth, getTopLeft, containsExtent, containsCoordinate, createEmpty, extend } from 'ol/extent';
import GeoJSON from 'ol/format/GeoJSON';
import { Vector as Vector$1 } from 'ol/layer';
import { Vector } from 'ol/source';
import { Style, Icon, Stroke, Fill, Text } from 'ol/style';
import Feature from 'ol/Feature';
import { Point } from 'ol/geom';
import ol_layer_Tile from 'ol/layer/Tile';
import { get } from 'ol/proj';
import ol_source_XYZ from 'ol/source/XYZ';
import ol_source_OSM from 'ol/source/OSM';
import ol_source_WMTS from 'ol/source/WMTS';
import ol_tilegrid_WMTS from 'ol/tilegrid/WMTS';
import ol_source_TileWMS from 'ol/source/TileWMS';
import { AppInjector, MessageError, AlertType } from 'base-models';
import { MatDialogConfig, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { Validators, FormBuilder, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, RequiredValidator, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorcontrolService, DialogHeader1Component, MessagebarComponent, BaseComponentsModule } from 'basecomponents';
import { NgIf, NgClass, NgForOf, CommonModule } from '@angular/common';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { SortHelper } from 'shtools';
import { MatProgressBar, MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import IconAnchorUnits from 'ol/style/IconAnchorUnits';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ScrollingModule } from '@angular/cdk/scrolling';

class FrCoordinate {
    constructor(x, //latitud
    y, //longitud
    zoom, projection = 'EPSG:4326') {
        this.x = x;
        this.y = y;
        this.zoom = zoom;
        this.projection = projection;
    }
}

class FrLayer {
    constructor(name, id, minZoom, maxZoom, ref, refObject, styles, 
    /**
     * Icon to show in layer list
     */
    icon, 
    /**
     * Type layer to show in layer list
     */
    layerType, 
    /**
     * tooltip to show in layer list
     */
    tooltip, zoomToExtent) {
        this.name = name;
        this.id = id;
        this.minZoom = minZoom;
        this.maxZoom = maxZoom;
        this.ref = ref;
        this.refObject = refObject;
        this.styles = styles;
        this.icon = icon;
        this.layerType = layerType;
        this.tooltip = tooltip;
        this.zoomToExtent = zoomToExtent;
        /**
         * Show hide on layer list
         */
        this.list = true;
    }
}

class IFrLayer {
}

var mapcte;
(function (mapcte) {
    mapcte["frlayerinfo_FieldName"] = "frlayerinfo";
    mapcte["RASTERPANELS"] = "RASTERPANELS";
})(mapcte || (mapcte = {}));

/**
 * Helper class for rectangle for maps
 */
class MRectangle {
    /**
     * Return as Extent using X,Y Format or Lon,Lat
     */
    getAsExtent() {
        return [this.left, this.top, this.right, this.bottom];
    }
    /**
     * Return Rectangle as String Extent (Top_X,Top_Y,Bottom_X, Bottom_Y)
     */
    getExtentAsString() {
        return this.left + ',' + this.top + ',' + this.right + ',' + this.bottom;
    }
}

/**
 * token to inject service by name
 */
const MAPS_CONFIG_TOKEN = 'MAPS_CONFIG_TOKEN';
const MAPS_CONFIG_TOKEN_DEFAULT = {
    config: { maps: [] }
};

class OlMarker {
    constructor(mapc) {
        this.mapc = mapc;
        this.map = mapc.map;
    }
    markerCreate(lon, lat, layer) {
        //console.log(lon, lat);
        let frlayerinfo = new FrLayer('icon', 'cio');
        if (!layer) {
            layer = this.mapc.layerCreateVectorLayer(frlayerinfo);
        }
        let feature = new Feature({
            geometry: new Point([lon, lat])
        });
        let markerStyle = new Style({
            image: new Icon(({
                //color: '#ece60f'
                crossOrigin: 'anonymous',
                src: 'assets/ol/marker1.png',
                scale: 1,
            }))
        });
        feature.setStyle(markerStyle);
        layer.getSource().addFeature(feature);
    }
}

class MapControlAction {
    constructor(action) {
        this.icon = action.icon;
        this.disabled = action.disabled ? action.disabled : false;
        this.titleText = action.titleText ? action.titleText : '';
        this.callBack = action.callBack;
    }
    onClick() {
        if (!this.callBack) {
            return;
        }
        this.callBack();
    }
}

class OlMapOptions {
    //previewCustom?: (index: number) => void;
    constructor(obj) {
        this.showCoords = false;
        this.showCoordsFormat = "Lat:[LAT] Lon:[LON]";
        this.showCoordsdecimals = 4;
        this.showFilters = false;
        function use(source, defaultValue) {
            return obj && (source !== undefined) ? source : defaultValue;
        }
        this.width = use(obj.width, '100%');
        this.height = use(obj.height, '400px');
        this.zoomPosition = use(obj.zoomPosition, 'LEFT');
        this.showCoords = use(obj.showCoords, false);
        this.showFilters = use(obj.showFilters, false);
        if (obj && obj.actions && obj.actions.length) {
            obj.actions = obj.actions.map(action => new MapControlAction(action));
        }
        this.actions = use(obj.actions, []);
        // this.previewCustom = use(obj.previewCustom, undefined);
    }
}

class MapRasterHelper {
    // map:Map;
    constructor() {
        //   this.map=mapc.map;
    }
    static loadPNOAmap(map, projectiontoset) {
        if (!map) {
            return;
        }
        const projection = get(projectiontoset);
        //var projection = ol.proj.get('EPSG:3857');
        const projectionExtent = projection.getExtent();
        const size = getWidth(projectionExtent) / 512;
        //var size = ol.extent.getWidth(projectionExtent) / 256;
        const resolutions = new Array(18);
        const matrixIds = new Array(18);
        for (let z = 0; z < 18; ++z) {
            // generate resolutions and matrixIds arrays for this WMTS
            resolutions[z] = size / Math.pow(2, z);
            matrixIds[z] = "EPSG:4326:" + z;
            //matrixIds[z] = z;
        }
        const tileGrid = new ol_tilegrid_WMTS({
            origin: getTopLeft(projectionExtent),
            resolutions: resolutions,
            matrixIds: matrixIds
        });
        const layer = new ol_layer_Tile({
            source: new ol_source_WMTS({
                url: 'http://www.ign.es/wmts/pnoa-ma',
                layer: 'OI.OrthoimageCoverage',
                matrixSet: 'EPSG:4326',
                format: 'image/png',
                projection: projection,
                tileGrid: tileGrid,
                style: ''
            })
        });
        layer[mapcte.frlayerinfo_FieldName] = new FrLayer('WMTS', 'pnoa');
        map.layerAdd(layer);
    }
    static loadOpenStreetMap(map) {
        const layer = new ol_layer_Tile({
            source: new ol_source_XYZ({
                url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'
            })
        });
        layer[mapcte.frlayerinfo_FieldName] = new FrLayer('OSM', 'OSM');
        map.layerAdd(layer);
    }
    static loadESRIMap(map, visible = true) {
        /*       let source= new ol_source_XYZ({
                attributions: ['Powered by Esri',
                               'Source: Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community'],
                attributionsCollapsible: false,
                url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                maxZoom: 23
              }); */
        let source = new ol_source_XYZ({
            url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            maxZoom: 20
        });
        const layer = new ol_layer_Tile({
            source: source
        });
        layer[mapcte.frlayerinfo_FieldName] = new FrLayer('Satellite', 'ESRI');
        layer[mapcte.frlayerinfo_FieldName].list = false;
        map.addLayer(layer);
    }
    static loadSitesMap(gis_configuration, map, visible = true, projection = "EPSG:4326") {
        let source = new ol_source_TileWMS({
            url: gis_configuration.gis_server_url + gis_configuration.gis_base_service_raster_url,
            params: { 'LAYERS': gis_configuration.layers["hd_base_layer"] },
            projection: projection
        });
        let layer = new ol_layer_Tile({
            source: source
        });
        layer.setVisible(visible);
        layer[mapcte.frlayerinfo_FieldName] = new FrLayer('GeoAI Site HD', 'GEOAISITES');
        map.addLayer(layer);
    }
    static loadPanelsMap(gis_configuration, map, visible = true, projection = "EPSG:4326") {
        let source = new ol_source_TileWMS({
            url: gis_configuration.gis_server_url + gis_configuration.gis_base_service_raster_url,
            params: { 'LAYERS': gis_configuration.layers["site_panels"] },
            projection: projection
        });
        let layer = new ol_layer_Tile({
            source: source
        });
        layer.setVisible(visible);
        layer.setMinZoom(10);
        let frlayer = new FrLayer('Site raster panels', mapcte.RASTERPANELS);
        frlayer.tooltip = "Layer with panels as raster images.";
        layer[mapcte.frlayerinfo_FieldName] = frlayer;
        map.addLayer(layer);
    }
    static loadDefaultLayerGoogleMaps(map) {
        if (!map) {
            return;
        }
        /*   const googleLayerSatellite = new TileLayer({
            title: "Google Satellite",
            source: new TileImage({ url: 'http://mt.google.com/vt/lyrs=s&hl=pl&&x={x}&y={y}&z={z}' }),
          }); */
        /*     const googleLayerSatellite = new OL_layer_tile({
              title: "Google Satellite",
              source: new TileImage({ url: 'http://maps.google.com/maps/vt?pb=!1m5!1m4!1i{z}!2i{x}!3i{y}!4i256!2m3!1e0!2sm!3i375060738!3m9!2spl!3sUS!5e18!12m1!1e47!12m3!1e37!2m1!1ssmartmaps!4e0'}),
            }); */
        const googleLayerSatellite = new ol_layer_Tile({
            source: new ol_source_OSM({
                url: 'http://mt{0-3}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}'
            })
        });
        googleLayerSatellite[mapcte.frlayerinfo_FieldName] = new FrLayer('Google Satellite', 'Google Satellite');
        map.addLayer(googleLayerSatellite);
    }
}
MapRasterHelper.feat_count = 0;
MapRasterHelper.featureAddedCount = 0;

;
class OlMapBaseComponent {
    constructor(config_service) {
        /**
       * generic map server url
       */
        this.GIS_SERVER_URL = "https://gis.geoaitech.com";
        this.gis_configuration = {};
        /** Map id
         */
        this.id = "map_" + Math.floor(Math.random() * 10000);
        this.options = new OlMapOptions({});
        /** Zoom of the map
         */
        this.zoom = 2;
        this.location = new FrCoordinate(-15.480362088220684, 27.969848091770977, 2);
        this.projection = 'EPSG:4326';
        this.layerVisibilityChanged = new EventEmitter();
        this.coordsFormated = "Lat:0 Lon:0";
        if (config_service) {
            let cfg = config_service.config["gis_configuration"];
            console.log("Map base loading settings", cfg);
            this.GIS_SERVER_URL = cfg["gis_server_url"];
            this.gis_configuration = cfg;
        }
        /* const injector = AppInjector.getInjector();
        this.dialog = injector.get(MatDialog); */
        this.onClick = new EventEmitter();
        this.onDblClick = new EventEmitter();
        this.onMoveEnd = new EventEmitter();
        this.onPointerDrag = new EventEmitter();
        this.onPointerMove = new EventEmitter();
        //this.onPostCompose = new EventEmitter<render.Event>();
        this.onPostRender = new EventEmitter();
        //this.onPreCompose = new EventEmitter<render.Event>();
        this.onPropertyChange = new EventEmitter();
        this.onSingleClick = new EventEmitter();
        this.onFeatureClick = new EventEmitter();
        this.marker = new OlMarker(this);
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        this.createMap();
        this.configEvents(this.map);
        this.configMapCommonUtils();
        this.map.setTarget(this.id);
        this.refreshSize();
        let cls = this;
        //for window onresize, works
        window.onresize = function () {
            setTimeout(function () {
                if (cls.map) {
                    cls.map.updateSize();
                }
                console.log("OpenLayers Window.onresize 500;");
            }.bind(this), 200);
        };
    }
    /**
     * Refresh map size
     */
    refreshSize() {
        let cls = this;
        setTimeout(function () {
            console.log("OpenLayers start updateSize", this.map);
            if (cls.map) {
                cls.map.updateSize();
            }
        }.bind(this), 100);
    }
    ngOnChanges(changes) {
        let typeChange = changes['location'];
        if (typeChange && (!typeChange.firstChange || typeChange.previousValue == undefined)) {
            this.setLocation(this.location);
        }
    }
    configEvents(map) {
        this.map.on('click', (event) => this.onClickHandler(event));
        this.map.on('dblclick', (event) => this.onDblClick.emit(event));
        this.map.on('moveend', (event) => this.onMoveEnd.emit(event));
        this.map.on('pointerdrag', (event) => this.onPointerDrag.emit(event));
        this.map.on('pointermove', (event) => this.onPointerMoveHandler(event));
        //this.map.on('postcompose', (event: render.Event) => this.onPostCompose.emit(event));
        this.map.on('postrender', (event) => this.onPostRender.emit(event));
        //this.map.on('precompose', (event: render.Event) => this.onPreCompose.emit(event));
        //this.map.on('propertychange', (event: ObjectEvent) => this.onPropertyChange.emit(event));//no existe en esta version?
        this.map.on('singleclick', (event) => this.onSingleClickHandler(event));
    }
    onClickHandler(event) {
        this.mousePositionClicked = event.coordinate[0] + "," + event.coordinate[1];
        console.log("Zoom: " + this.zoomUpdateManually() + " XY:" + this.mousePositionClicked);
        this.onClick.emit(event);
    }
    onSingleClickHandler(event) {
        this.onSingleClick.emit(event);
        let pixel = event.pixel;
        this.displayFeatureInfo(pixel);
    }
    displayFeatureInfo(pixel) {
        let features = [];
        let hit = this.map.hasFeatureAtPixel(pixel);
        if (!hit) {
            return;
        }
        this.map.forEachFeatureAtPixel(pixel, function (feature, layer) {
            if (layer) {
                const isVisible = layer.getVisible();
                if (isVisible == true) {
                    features.push({ feature: feature, layer: layer });
                }
            }
        });
        if (features.length > 0) {
            this.onFeatureClick.emit(features);
        }
    }
    ;
    onPointerMoveHandler(event) {
        if (event.dragging) {
            return;
        }
        this.map.getTargetElement().style.cursor = this.map.hasFeatureAtPixel(event.pixel) ? 'pointer' : '';
        this.coords = event.coordinate;
        let latitude = this.coords[1].toFixed(this.options.showCoordsdecimals);
        let longitude = this.coords[0].toFixed(this.options.showCoordsdecimals);
        this.coordsFormated = this.options.showCoordsFormat.replace("[LAT]", latitude);
        this.coordsFormated = this.coordsFormated.replace("[LON]", longitude);
        this.onPointerMove.emit(event);
    }
    viewContainExtent(coords) {
        return containsExtent(this.map_view.calculateExtent(), coords);
    }
    viewContainCoords(coords) {
        let ext = this.map_view.calculateExtent();
        return containsCoordinate(ext, coords);
    }
    setLocation(newLocation) {
        if (!newLocation) {
            return;
        }
        if (newLocation instanceof FrCoordinate) {
            this.location = newLocation;
            this.setCenter(newLocation.x, newLocation.y, newLocation.zoom);
        }
        else {
            this.location.x = newLocation[0];
            this.location.y = newLocation[1];
            this.setCenter(this.location.x, this.location.y, this.zoom);
        }
    }
    setCenter(x, y, zoom) {
        this.map.getView().setCenter([x || 0, y || 0]);
        if (zoom) {
            this.setZoom(zoom);
        }
    }
    setZoom(zoom) {
        this.zoom = zoom;
        try {
            this.map.getView().setZoom(this.zoom);
        }
        catch (err) {
            console.log(err);
        }
    }
    getZoom() {
        return this.zoomUpdateManually();
    }
    /**
     * Because we haven´t an event to know the change in zoom we need to update the value manually
     */
    zoomUpdateManually() {
        const z = this.map.getView().getZoom();
        this.zoom = z;
        return z;
    }
    zoomUpgrade(newZoom) {
        this.zoomUpdateManually();
        if (this.zoom < newZoom) {
            this.setZoom(newZoom);
        }
    }
    setLocationBounce(newLocation) {
        // bounce by zooming out one level and back in
        /*     let bounce = ol_View.bounce({
              resolution: this.map.getView().getResolution() * 2
            });
            // start the pan at the current center of the map
            let pan = ol_View.pan({
              source: this.map.getView().getCenter()
            });
            this.map.beforeRender(bounce);
            this.map.beforeRender(pan); */
        // when we set the center to the new location, the animated move will
        // trigger the bounce and pan effects
        this.setLocation(newLocation);
    }
    setZoomToExtent(layer, duration = 0) {
        try {
            if (!layer) {
                return;
            }
            let layerExtent = layer.getSource().getExtent();
            if (layerExtent) {
                let view = this.map.getView();
                view.fit(layerExtent, { padding: [60, 60, 60, 20], duration: duration });
            }
        }
        catch (err) {
            console.log(err);
        }
    }
    configMapCommonUtils() {
        this.map.addControl(new ZoomSlider());
        //this.map.addControl(new ol_control.FullScreen());
        this.map.addControl(new ScaleLine());
    }
    addinteractionExt(selectInteraction) {
        this.map.getInteractions().extend([selectInteraction]);
    }
    layerCreateVectorLayer(layerinfo) {
        const vectorSource = new Vector();
        // Create vector layer attached to the vector source.
        const vectorLayer = new Vector$1({
            source: vectorSource
            /*  ,style: layerinfo.styles */
        });
        if (layerinfo.minZoom > 0) {
            vectorLayer.setMinZoom(layerinfo.minZoom);
        }
        if (layerinfo.maxZoom > 0) {
            vectorLayer.setMaxZoom(layerinfo.maxZoom);
        }
        vectorLayer[mapcte.frlayerinfo_FieldName] = layerinfo;
        return vectorLayer;
    }
    vectorSourcecreate(geojsonObject) {
        const vectorSource = new Vector({ features: (new GeoJSON()).readFeatures(geojsonObject) });
        return vectorSource;
    }
    createMap() {
        if (!this.location) {
            this.location = new FrCoordinate(-2.17779138970374, 37.014504662942514, 18);
        }
        //controls: defaultControls().extend([this.mousePositionInit()]),
        this.map_view = new ol_View({
            projection: this.projection,
            center: [this.location.x, this.location.y, 14],
            zoom: 14,
            maxZoom: 23.5
        });
        this.map = new Map({
            view: this.map_view,
        });
        //target: this.id
        //this.loadPNOAmap();
        MapRasterHelper.loadESRIMap(this.map);
        MapRasterHelper.loadSitesMap(this.gis_configuration, this.map);
        MapRasterHelper.loadPanelsMap(this.gis_configuration, this.map);
        //this.map.controls.defaultControls().extend([this.mousePositionInit()])
        //this.loadOpenStreetMap();
        //this.loadDefaultLayerGoogleMaps();
    }
    /**
     * Return layer with selected id and frid property
     * @param frid
     */
    layerGetByFrid(frid) {
        frid = this.layerGetFrid(frid);
        //const layers: any = this.map.getLayers().array_; //array_ 
        const layers = this.map.getLayers().getArray();
        const res = layers.find(el => el[mapcte.frlayerinfo_FieldName].id == frid);
        return res;
    }
    layerAdd(layer) {
        if (this.map) {
            this.map.addLayer(layer);
        }
    }
    /**
     * Show hide layer
     * @param frid
     */
    layerShowHide(frid) {
        frid = this.layerGetFrid(frid);
        const res = this.layerGetByFrid(frid);
        if (res) {
            const isVisible = !res.getVisible();
            res.setVisible(isVisible);
            this.layerVisibilityChanged.next(res);
            return isVisible;
        }
        return false;
    }
    /**
     * show layer by frid id
     * @param frid
     */
    layerShow(frid) {
        frid = this.layerGetFrid(frid);
        const res = this.layerGetByFrid(frid);
        if (res) {
            res.setVisible(true);
            this.layerVisibilityChanged.next(res);
        }
    }
    /**
     * hide layer by frid id
     * @param frid
     */
    layerHide(frid) {
        if (!frid) {
            return;
        }
        frid = this.layerGetFrid(frid);
        const res = this.layerGetByFrid(frid);
        if (res) {
            res.setVisible(false);
            this.layerVisibilityChanged.next(res);
        }
    }
    /**
     * Remove layer by frid id
     * @param frid
     */
    layerRemove(frid) {
        frid = this.layerGetFrid(frid);
        const res = this.layerGetByFrid(frid);
        if (res) {
            let deleted = this.map.removeLayer(res);
            return deleted;
        }
        return null;
    }
    layerGetFrid(frid) {
        if (frid instanceof Vector$1) {
            frid = frid[mapcte.frlayerinfo_FieldName].id;
        }
        else {
            frid = frid;
        }
        return frid;
    }
    /**
     * Config the mouse position to see coords in view
     */
    mousePositionInit() {
        //https://openlayers.org/en/latest/apidoc/module-ol_control_MousePosition-MousePosition.html
        let mousePositionControl = new MousePosition({
            coordinateFormat: createStringXY(16),
            projection: this.projection,
            // comment the following two lines to have the mouse position
            // be placed within the map.
            className: 'custom-mouse-position',
            target: this.mousePosition,
            undefinedHTML: '&nbsp;'
        });
        //undefinedHTML: Markup to show when coordinates are not available (e.g. when the pointer leaves the map viewport). 
        //By default, the last position will be replaced with '&#160;' (&nbsp;) when the pointer leaves the viewport. 
        //To retain the last rendered position, set this option to something falsey (like an empty string '').
        return mousePositionControl;
    }
    loadGeoData(layername, data, id) {
        this.layerRemove(id);
        let vectorSource = new Vector({ features: (new GeoJSON()).readFeatures(data) });
        let vectorLayer = new Vector$1({
            source: vectorSource
        });
        //let obj:any=vectorLayer;
        //obj.frlayerinfo = new FrLayer(layername, id);
        //vectorLayer.frlayerinfo = new FrLayer(layername, id);
        vectorLayer[mapcte.frlayerinfo_FieldName] = new FrLayer(layername, id);
        this.layerAdd(vectorLayer);
        return vectorLayer;
    }
}
OlMapBaseComponent.ɵfac = function OlMapBaseComponent_Factory(t) { return new (t || OlMapBaseComponent)(ɵɵdirectiveInject(MAPS_CONFIG_TOKEN)); };
OlMapBaseComponent.ɵcmp = ɵɵdefineComponent({ type: OlMapBaseComponent, selectors: [["ng-component"]], inputs: { GIS_SERVER_URL: "GIS_SERVER_URL", gis_configuration: "gis_configuration", id: "id", options: "options", lon: "lon", lat: "lat", zoom: "zoom", location: "location", projection: "projection" }, outputs: { layerVisibilityChanged: "layerVisibilityChanged", onClick: "onClick", onDblClick: "onDblClick", onMoveEnd: "onMoveEnd", onPointerDrag: "onPointerDrag", onPointerMove: "onPointerMove", onPostRender: "onPostRender", onPropertyChange: "onPropertyChange", onSingleClick: "onSingleClick", onFeatureClick: "onFeatureClick" }, features: [ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function OlMapBaseComponent_Template(rf, ctx) { }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(OlMapBaseComponent, [{
        type: Component,
        args: [{
                selector: '',
                template: ''
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAPS_CONFIG_TOKEN]
            }] }]; }, { GIS_SERVER_URL: [{
            type: Input
        }], gis_configuration: [{
            type: Input
        }], id: [{
            type: Input
        }], options: [{
            type: Input
        }], lon: [{
            type: Input
        }], lat: [{
            type: Input
        }], zoom: [{
            type: Input
        }], location: [{
            type: Input
        }], projection: [{
            type: Input
        }], layerVisibilityChanged: [{
            type: Output
        }], onClick: [{
            type: Output
        }], onDblClick: [{
            type: Output
        }], onMoveEnd: [{
            type: Output
        }], onPointerDrag: [{
            type: Output
        }], onPointerMove: [{
            type: Output
        }], onPostRender: [{
            type: Output
        }], onPropertyChange: [{
            type: Output
        }], onSingleClick: [{
            type: Output
        }], onFeatureClick: [{
            type: Output
        }] }); })();

function OlLayerAddComponent_app_frms_messagebar_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "app-frms-messagebar", 14);
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("alertmessage", ctx_r0.alertmessage);
} }
function OlLayerAddComponent_ng_container_7_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 20);
    ɵɵtext(1, " Name is required ");
    ɵɵelementEnd();
} }
function OlLayerAddComponent_ng_container_7_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 20);
    ɵɵtext(1, " Name must be at least 3 characters long. ");
    ɵɵelementEnd();
} }
function OlLayerAddComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 15);
    ɵɵelementStart(2, "label", 16);
    ɵɵtext(3, "* Layer name ");
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 17);
    ɵɵelement(5, "input", 18);
    ɵɵtemplate(6, OlLayerAddComponent_ng_container_7_div_6_Template, 2, 0, "div", 19);
    ɵɵtemplate(7, OlLayerAddComponent_ng_container_7_div_7_Template, 2, 0, "div", 19);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(5);
    ɵɵproperty("ngClass", !ctx_r1.myform.get("name").valid ? "is-invalid" : "");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.myform.get("name").hasError("required"));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.myform.get("name").hasError("minlength"));
} }
function OlLayerAddComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 15);
    ɵɵelementStart(2, "label", 16);
    ɵɵtext(3, "Layer name ");
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 17);
    ɵɵelement(5, "input", 21);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
class OlLayerAddComponent {
    constructor(fb, data) {
        this.fb = fb;
        this.data = data;
        /**
         * name to identify the class
         */
        this.TAG = "OlLayerAddComponent";
        this.title = "Add layer";
        this.titlesub = "";
        this.hasBaseDropZoneOver = false;
        this.geojson = "";
        this.layerName = "";
        this.layerId = "";
        this.layerNameEditable = true;
        this.fileMessage = "Choose file with GeoData";
        if (data != null) {
            if (data.layerName) {
                this.layerName = data.layerName;
            }
            if (data.layerId) {
                this.layerId = data.layerId;
            }
            if (data.layerNameEditable !== null) {
                this.layerNameEditable = data.layerNameEditable;
            }
            if (data.title) {
                this.title = data.title;
            }
            if (data.titlesub) {
                this.titlesub = data.titlesub;
            }
        }
        this.createForm();
    }
    ngOnInit() {
    }
    showerror(message, err) {
        this.alertmessage = ErrorcontrolService.basichandleError(message, err, null, this.TAG);
    }
    isvalid() {
        if (this.fileContents == null || this.fileContents.length == 0) {
            return false;
        }
        return true;
    }
    okaction() {
        if (this.fileContents == null || this.fileContents.length == 0) {
            this.showerror("Please select a valid file with geodata.");
            return;
        }
        const formModel = this.myform.value;
        let res;
        let geojson = this.fileContents; //(formModel.geom)
        if (this.layerNameEditable) {
            res = { name: formModel.name, geom: geojson, layerId: this.layerId };
        }
        else {
            res = { name: this.layerName, geom: geojson, layerId: this.layerId };
        }
        this.dialogRef.close(res);
    }
    static openModal(dialog, dialogData) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = "700px";
        dialogConfig.data = dialogData;
        let dialogRef;
        dialogRef = dialog.open(OlLayerAddComponent, dialogConfig);
        dialogRef.componentInstance.dialogRef = dialogRef;
        return dialogRef;
    }
    createForm() {
        /*   let fcname: any;
            if (this.layerNameEditable) {
             fcname = new FormControl({ value: this.layerName }, [Validators.required, Validators.minLength(3)]);
           }
           else {
             fcname = new FormControl({ value: this.layerName, disabled: true });
           } */
        this.myform = this.fb.group({
            name: [this.layerName, [Validators.required, Validators.minLength(3)]],
            filename: ['', [Validators.required]],
        });
    }
    fileChangeEvent($event) {
        try {
            //console.log("fileChangeEvent", event);
            let files = $event.target.files;
            let msg = "";
            for (let f of files) {
                msg += f.name;
                this.readFileContents(f);
            }
            this.fileMessage = msg;
        }
        catch (err) {
            this.showerror("Error ocurred with file selected. ", err);
        }
    }
    readFileContents(file) {
        let reader = new FileReader();
        this.fileContents = null;
        reader.onload = this.handleFileLoad.bind(this);
        reader.readAsText(file);
    }
    handleFileLoad(event) {
        this.fileContents = event.target.result;
    }
}
OlLayerAddComponent.ɵfac = function OlLayerAddComponent_Factory(t) { return new (t || OlLayerAddComponent)(ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
OlLayerAddComponent.ɵcmp = ɵɵdefineComponent({ type: OlLayerAddComponent, selectors: [["app-ol-layer-add"]], decls: 22, vars: 9, consts: [["mat-dialog-title", "", 3, "title", "titlesub", "classtype"], [3, "alertmessage", 4, "ngIf"], [3, "formGroup"], [1, "container-fluid"], [1, "form-hint"], [4, "ngIf"], [1, "row", "mb-3"], [1, "col"], [1, "custom-file"], ["type", "file", "formControlName", "filename", "id", "customFile", 1, "custom-file-input1", 3, "change"], ["for", "customFile", 1, "custom-file-label"], ["mat-dialog-actions", "", 1, "justify-content-end", 2, "width", "100%"], ["mat-raised-button", "", "type", "button", 1, "btn", "btn-success", "pull-right", 3, "disabled", "click"], ["mat-raised-button", "", "mat-dialog-close", "", 1, "btn", "pull-right"], [3, "alertmessage"], [1, "form-group", "row"], ["for", "name", 1, "col-sm-3", "col-form-label"], [1, "col-sm-9"], ["id", "name", "formControlName", "name", "type", "text", "required", "", "placeholder", "Enter layer name", 1, "form-control", "form-control-sm", 3, "ngClass"], ["class", "invalid-feedback", 4, "ngIf"], [1, "invalid-feedback"], ["id", "name", "formControlName", "name", "type", "text", "placeholder", "Enter layer name", "readonly", "", 1, "form-control", "form-control-sm"]], template: function OlLayerAddComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "app-layout-dialogheader1", 0);
        ɵɵelementStart(1, "mat-dialog-content");
        ɵɵtemplate(2, OlLayerAddComponent_app_frms_messagebar_2_Template, 1, 1, "app-frms-messagebar", 1);
        ɵɵelementStart(3, "form", 2);
        ɵɵelementStart(4, "div", 3);
        ɵɵelementStart(5, "p", 4);
        ɵɵtext(6, "Fields with * are required");
        ɵɵelementEnd();
        ɵɵtemplate(7, OlLayerAddComponent_ng_container_7_Template, 8, 3, "ng-container", 5);
        ɵɵtemplate(8, OlLayerAddComponent_ng_container_8_Template, 6, 0, "ng-container", 5);
        ɵɵelementStart(9, "div", 6);
        ɵɵelementStart(10, "div", 7);
        ɵɵelementStart(11, "h3");
        ɵɵtext(12, "Select file based on Geographical Coordinate System (EPSG:4326)");
        ɵɵelementEnd();
        ɵɵelementStart(13, "div", 8);
        ɵɵelementStart(14, "input", 9);
        ɵɵlistener("change", function OlLayerAddComponent_Template_input_change_14_listener($event) { return ctx.fileChangeEvent($event); });
        ɵɵelementEnd();
        ɵɵelementStart(15, "label", 10);
        ɵɵtext(16);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(17, "div", 11);
        ɵɵelementStart(18, "button", 12);
        ɵɵlistener("click", function OlLayerAddComponent_Template_button_click_18_listener() { return ctx.okaction(); });
        ɵɵtext(19, "Apply");
        ɵɵelementEnd();
        ɵɵelementStart(20, "button", 13);
        ɵɵtext(21, "Close");
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("title", ctx.title)("titlesub", ctx.titlesub)("classtype", "bluehead");
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.alertmessage);
        ɵɵadvance(1);
        ɵɵproperty("formGroup", ctx.myform);
        ɵɵadvance(4);
        ɵɵproperty("ngIf", ctx.layerNameEditable);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.layerNameEditable);
        ɵɵadvance(8);
        ɵɵtextInterpolate(ctx.fileMessage);
        ɵɵadvance(2);
        ɵɵproperty("disabled", !ctx.isvalid());
    } }, directives: [DialogHeader1Component, MatDialogTitle, MatDialogContent, NgIf, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, MatDialogActions, MatButton, MatDialogClose, MessagebarComponent, RequiredValidator, NgClass], styles: [".mat-dialog-content[_ngcontent-%COMP%]{overflow-y:hidden}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(OlLayerAddComponent, [{
        type: Component,
        args: [{
                selector: 'app-ol-layer-add',
                templateUrl: './ol-layer-add.component.html',
                styleUrls: ['./ol-layer-add.component.scss']
            }]
    }], function () { return [{ type: FormBuilder }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

const _c0 = ["map"];
function OlMainComponent_nav_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 18);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r6.title);
} }
function OlMainComponent_nav_1_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", 15);
    ɵɵelementStart(1, "button", 16);
    ɵɵlistener("click", function OlMainComponent_nav_1_li_6_Template_button_click_1_listener() { ɵɵrestoreView(_r9); const ctx_r8 = ɵɵnextContext(2); return ctx_r8.layerAddManual(); });
    ɵɵelement(2, "i", 17);
    ɵɵtext(3, " Add");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function OlMainComponent_nav_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "nav", 9);
    ɵɵelementStart(1, "div");
    ɵɵtemplate(2, OlMainComponent_nav_1_span_2_Template, 2, 1, "span", 10);
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 11);
    ɵɵelement(4, "div", 12);
    ɵɵelementStart(5, "ul", 13);
    ɵɵtemplate(6, OlMainComponent_nav_1_li_6_Template, 4, 0, "li", 14);
    ɵɵelementStart(7, "li", 15);
    ɵɵelementStart(8, "button", 16);
    ɵɵlistener("click", function OlMainComponent_nav_1_Template_button_click_8_listener() { ɵɵrestoreView(_r11); const ctx_r10 = ɵɵnextContext(); return ctx_r10.layersShowPanel(); });
    ɵɵelement(9, "i", 17);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r0.title);
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r0.btnAddlayersViewVisible);
} }
function OlMainComponent_mat_progress_bar_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "mat-progress-bar", 19);
} }
function OlMainComponent_app_frms_messagebar_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "app-frms-messagebar", 20);
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("alertmessage", ctx_r2.alertmessage)("compact", true);
} }
function OlMainComponent_ng_container_7_div_5_tr_10_li_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "li", 40);
    ɵɵelement(1, "img", 41);
    ɵɵelementEnd();
} if (rf & 2) {
    const row_r15 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵproperty("src", row_r15.frlayerinfo == null ? null : row_r15.frlayerinfo.icon, ɵɵsanitizeUrl);
} }
function OlMainComponent_ng_container_7_div_5_tr_10_li_8_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", 40);
    ɵɵelementStart(1, "a", 42);
    ɵɵlistener("click", function OlMainComponent_ng_container_7_div_5_tr_10_li_8_Template_a_click_1_listener() { ɵɵrestoreView(_r22); const row_r15 = ɵɵnextContext().$implicit; const ctx_r20 = ɵɵnextContext(3); return ctx_r20.zoomToExtent(row_r15); });
    ɵɵelement(2, "i", 43);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function OlMainComponent_ng_container_7_div_5_tr_10_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "tr");
    ɵɵelementStart(1, "td", 34);
    ɵɵelementStart(2, "div", 35);
    ɵɵelementStart(3, "input", 36);
    ɵɵlistener("change", function OlMainComponent_ng_container_7_div_5_tr_10_Template_input_change_3_listener($event) { ɵɵrestoreView(_r24); const row_r15 = ctx.$implicit; const ctx_r23 = ɵɵnextContext(3); return ctx_r23.layerShowHide_click($event, row_r15); });
    ɵɵelementEnd();
    ɵɵelementStart(4, "label", 37);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementStart(6, "ul", 38);
    ɵɵtemplate(7, OlMainComponent_ng_container_7_div_5_tr_10_li_7_Template, 2, 1, "li", 39);
    ɵɵtemplate(8, OlMainComponent_ng_container_7_div_5_tr_10_li_8_Template, 3, 0, "li", 39);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const row_r15 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵpropertyInterpolate("matTooltip", row_r15.frlayerinfo == null ? null : row_r15.frlayerinfo.tooltip);
    ɵɵadvance(2);
    ɵɵpropertyInterpolate1("id", "chk_", row_r15.frlayerinfo == null ? null : row_r15.frlayerinfo.id, "");
    ɵɵproperty("checked", row_r15.getVisible());
    ɵɵadvance(1);
    ɵɵpropertyInterpolate1("for", "chk_", row_r15.frlayerinfo == null ? null : row_r15.frlayerinfo.id, "");
    ɵɵadvance(1);
    ɵɵtextInterpolate(row_r15.frlayerinfo == null ? null : row_r15.frlayerinfo.name);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", row_r15.frlayerinfo == null ? null : row_r15.frlayerinfo.icon);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", row_r15.frlayerinfo == null ? null : row_r15.frlayerinfo.zoomToExtent);
} }
function OlMainComponent_ng_container_7_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 26);
    ɵɵelementStart(1, "div", 27);
    ɵɵelementStart(2, "div", 28);
    ɵɵelement(3, "i", 17);
    ɵɵtext(4, " Layers ");
    ɵɵelementStart(5, "span", 29);
    ɵɵlistener("click", function OlMainComponent_ng_container_7_div_5_Template_span_click_5_listener() { ɵɵrestoreView(_r26); const ctx_r25 = ɵɵnextContext(2); return ctx_r25.layersShowPanel(); });
    ɵɵelement(6, "i", 30);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 31);
    ɵɵelementStart(8, "table", 32);
    ɵɵelementStart(9, "tbody");
    ɵɵtemplate(10, OlMainComponent_ng_container_7_div_5_tr_10_Template, 9, 7, "tr", 33);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵɵnextContext(2);
    ɵɵadvance(10);
    ɵɵproperty("ngForOf", ctx_r12.layersGet());
} }
function OlMainComponent_ng_container_7_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 44);
    ɵɵelementStart(1, "button", 45);
    ɵɵlistener("click", function OlMainComponent_ng_container_7_div_6_Template_button_click_1_listener() { const action_r27 = ctx.$implicit; return action_r27.onClick(); });
    ɵɵelement(2, "i");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const action_r27 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵpropertyInterpolate("title", action_r27.titleText);
    ɵɵadvance(1);
    ɵɵclassMap(action_r27.icon);
} }
function OlMainComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 21);
    ɵɵelementStart(2, "div", 22);
    ɵɵelementStart(3, "button", 23);
    ɵɵlistener("click", function OlMainComponent_ng_container_7_Template_button_click_3_listener() { ɵɵrestoreView(_r30); const ctx_r29 = ɵɵnextContext(); return ctx_r29.layersShowPanel(); });
    ɵɵelement(4, "i", 17);
    ɵɵelementEnd();
    ɵɵtemplate(5, OlMainComponent_ng_container_7_div_5_Template, 11, 1, "div", 24);
    ɵɵelementEnd();
    ɵɵtemplate(6, OlMainComponent_ng_container_7_div_6_Template, 3, 4, "div", 25);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵadvance(5);
    ɵɵproperty("ngIf", ctx_r4.layersViewVisible);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r4.options.actions);
} }
function OlMainComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 46);
    ɵɵelementStart(1, "span");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r5.coordsFormated);
} }
class OlMainComponent extends OlMapBaseComponent {
    constructor(map_config) {
        super(map_config);
        this.title = "Map Information";
        this.showCardTitle = true;
        this.showButtonLayers = false;
        this.mapClass = "";
        this.mapHeight = "100%";
        this.mapWidth = "100%";
        this.showScaleLine = true;
        this.loadinglist = false;
        this.layersViewVisible = false; //show hide layers selector
        this.btnAddlayersViewVisible = false; //show hide layers add button
        this.layers = [];
        const injector = AppInjector.getInjector();
        this.dialog = injector.get(MatDialog);
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.options && this.options.zoomPosition == "RIGHT") {
            this.mapClass += " zoom-to-right";
        }
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
    }
    /**
    * Updates target and size of the map.
    *
    * @param target HTML container.
    */
    updateSizeV1() {
        this.map.setTarget(this.id);
        this.map.updateSize();
    }
    //colocar aqui solo los metodos necesarios a nivel interfaz
    layersShowPanel() {
        /*     const kk=map.getLayers();
            const layers: any = this.map.getLayers().array_;
            console.log("layers");
            layers.forEach(el => {
              console.log(el);
            }); */
        this.layersViewVisible = !this.layersViewVisible;
    }
    layerShowHide_click($event, row) {
        this.layerShowHide(row[mapcte.frlayerinfo_FieldName].id);
    }
    /**
     * Return the list of layers to show in layer selector
     */
    layersGet() {
        if (this.map) {
            const layers = this.map.getLayers().getArray();
            let list = layers.filter(el => el.hasOwnProperty('frlayerinfo'));
            list = list.filter(elem => elem[mapcte.frlayerinfo_FieldName].list == true);
            list = list.sort((a, b) => SortHelper.sortby(a.getZIndex(), b.getZIndex(), true));
            //console.log("layerget: ",list);
            return list;
        }
    }
    /**
     * Add a layer manual
     */
    layerAddManual(dialogData) {
        let dialogRef;
        dialogRef = OlLayerAddComponent.openModal(this.dialog, dialogData);
        /*     dialogRef.afterClosed().subscribe({
              next: (result: any) => {
                if (result) {
                  //result es dialogRef.componentInstance.geojson
                  this.loadGeoData(result.name, result.geom, result.name);
                }
              },
              error: (err: any) => {
                console.log(err);
              },
              complete: () => {
                console.log('complete');
              }
            }); */
        return dialogRef;
    }
    showmessage(message) {
        this.alertmessage = new MessageError(AlertType.Success, message);
    }
    zoomToExtent_old(row) {
        let layer = row;
        if (!layer) {
            return;
        }
        let extent = layer.getSource().getExtent();
        if (!extent || extent == undefined) {
            return;
        }
        this.map.getView().fit(extent, { padding: [60, 60, 60, 60] });
    }
    zoomToExtent(layer, duration = 0) {
        let featuresAs = layer.getSource().getFeatures();
        let map = this.map;
        let extent = createEmpty();
        for (let item of featuresAs) {
            let featuresList = item.get('features');
            if (featuresList != undefined) {
                featuresList.forEach(function (f, index, array) {
                    extend(extent, f.getGeometry().getExtent());
                });
            }
        }
        if (extent) {
            let view = map.getView();
            view.fit(extent, { padding: [60, 60, 60, 60], duration: duration });
        }
    }
    showFilter() {
    }
}
OlMainComponent.ɵfac = function OlMainComponent_Factory(t) { return new (t || OlMainComponent)(ɵɵdirectiveInject(MAPS_CONFIG_TOKEN)); };
OlMainComponent.ɵcmp = ɵɵdefineComponent({ type: OlMainComponent, selectors: [["app-ol-main"]], viewQuery: function OlMainComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        let _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.mapview = _t.first);
    } }, inputs: { title: "title", showCardTitle: "showCardTitle", showButtonLayers: "showButtonLayers", mapClass: "mapClass", mapHeight: "mapHeight", mapWidth: "mapWidth", showScaleLine: "showScaleLine" }, features: [ɵɵInheritDefinitionFeature], decls: 9, vars: 7, consts: [[1, "section-list", "card"], ["class", "navbar navbar-expand-sm navbar-light bg-light justify-content-between section-header mb-2", 4, "ngIf"], [1, "card-body", "map-container", "section-map"], ["mode", "indeterminate", 4, "ngIf"], [3, "alertmessage", "compact", 4, "ngIf"], [1, "map", 3, "ngClass"], ["map", ""], [4, "ngIf"], ["class", "ol-control-coords ol-unselectable ol-control ", 4, "ngIf"], [1, "navbar", "navbar-expand-sm", "navbar-light", "bg-light", "justify-content-between", "section-header", "mb-2"], ["class", "navbar-brand mb-0 h1", 4, "ngIf"], ["id", "navbarSupportedContent", 1, "collapse", "navbar-collapse"], [1, "navbar-nav", "ml-auto"], [1, "nav", "navbar-nav", "ml-auto"], ["class", "nav-item mr-1", 4, "ngIf"], [1, "nav-item", "mr-1"], ["role", "button", 1, "btn", "btn-outline-primary", "btn-sm", 3, "click"], [1, "fas", "fa-layer-group"], [1, "navbar-brand", "mb-0", "h1"], ["mode", "indeterminate"], [3, "alertmessage", "compact"], [1, "map-btn-nav"], [1, "ol-layer-switch", "ol-unselectable", "ol-control"], ["type", "button", "title", "Toggle layers", "role", "button", 3, "click"], ["class", "card layers-view", 4, "ngIf"], ["class", "ol-layer-action-control ol-unselectable ol-control ", 4, "ngFor", "ngForOf"], [1, "card", "layers-view"], [1, "layers-view-rel"], [1, "card-header", "tool"], [1, "section-minimize", 3, "click"], [1, "far", "fa-window-minimize"], [1, "layer-switch"], [1, "table", "table-bordered", "table-sm"], [4, "ngFor", "ngForOf"], [3, "matTooltip"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "id", "checked", "change"], [1, "custom-control-label", 3, "for"], [1, "nav", "ml-auto", "justify-content-end"], ["class", "nav-item", 4, "ngIf"], [1, "nav-item"], [1, "icon", "icon-right", 3, "src"], ["matTooltip", "Zoom to boundaries", 1, "nav-link", 3, "click"], [1, "fas", "fa-expand", "icon", "icon-right", "withpointer"], [1, "ol-layer-action-control", "ol-unselectable", "ol-control"], ["type", "button", "role", "button", 3, "title", "click"], [1, "ol-control-coords", "ol-unselectable", "ol-control"]], template: function OlMainComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, OlMainComponent_nav_1_Template, 10, 2, "nav", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵtemplate(3, OlMainComponent_mat_progress_bar_3_Template, 1, 0, "mat-progress-bar", 3);
        ɵɵtemplate(4, OlMainComponent_app_frms_messagebar_4_Template, 1, 2, "app-frms-messagebar", 4);
        ɵɵelementStart(5, "div", 5, 6);
        ɵɵtemplate(7, OlMainComponent_ng_container_7_Template, 7, 2, "ng-container", 7);
        ɵɵtemplate(8, OlMainComponent_div_8_Template, 3, 1, "div", 8);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showCardTitle);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.loadinglist);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.alertmessage);
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ctx.mapClass);
        ɵɵattribute("id", ctx.id);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.showButtonLayers);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.options.showCoords);
    } }, directives: [NgIf, NgClass, MatProgressBar, MessagebarComponent, NgForOf, MatTooltip], styles: [".section-list.card[_ngcontent-%COMP%]{height:100%;max-height:100%}.custom-mouse-position[_ngcontent-%COMP%]{color:#fff!important}.map[_ngcontent-%COMP%]{height:100%;width:100%}#info[_ngcontent-%COMP%]{background-color:#000;border:1px solid #ccc;color:#fff;font-size:18px;padding:5px;pointer-events:none;position:absolute;top:-10em;z-index:10}.mouse-position-clicked[_ngcontent-%COMP%]{font-size:.7rem;height:0;position:relative;top:-13px}.map-btn-nav[_ngcontent-%COMP%]{position:absolute;right:.5em;top:.5em;z-index:1}.layer-switch[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{height:20px}.ol-control-coords[_ngcontent-%COMP%]{background-color:rgba(0,0,0,.6);bottom:0;color:#fff;font-size:.75em;margin-bottom:3px!important;padding:2px 6px;right:0;text-align:center;z-index:1}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(OlMainComponent, [{
        type: Component,
        args: [{
                selector: 'app-ol-main',
                templateUrl: './ol-main.component.html',
                styleUrls: ['./ol-main.component.scss']
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAPS_CONFIG_TOKEN]
            }] }]; }, { title: [{
            type: Input
        }], showCardTitle: [{
            type: Input
        }], showButtonLayers: [{
            type: Input
        }], mapClass: [{
            type: Input
        }], mapHeight: [{
            type: Input
        }], mapWidth: [{
            type: Input
        }], showScaleLine: [{
            type: Input
        }], mapview: [{
            type: ViewChild,
            args: ['map', { static: true }]
        }] }); })();

class MapMarkerHelper {
    // map:Map;
    constructor() {
        this.markerStyle = new Style({
            image: new Icon(({
                //color: '#ece60f'
                crossOrigin: 'anonymous',
                src: 'assets/ol/marker1.png',
                scale: 1,
                anchor: [1, 1],
                anchorXUnits: IconAnchorUnits.FRACTION,
                anchorYUnits: IconAnchorUnits.FRACTION
            }))
        });
        //   this.map=mapc.map;
    }
    static markerCreate(ol_style_Style, lon, lat, id, text, parentLayer) {
        const feature = new Feature({ geometry: new Point([lon, lat]), text: text });
        feature[mapcte.frlayerinfo_FieldName] = new FrLayer(text, id);
        feature.setId(id);
        feature.setStyle(ol_style_Style);
        if (parentLayer) {
            parentLayer.getSource().addFeature(feature);
        }
        return feature;
    }
}

class MapOnMoveHelper {
    constructor(mapc) {
        this.mapc = mapc;
        this.listeners = new Array();
        this.map = mapc.map;
        mapc.onPointerMove.subscribe(res => this.onPointerMove(res));
    }
    onPointerMove(browserEvent) {
        const coordinate = browserEvent.coordinate;
        const pixel = browserEvent.pixel;
        let hit = this.map.hasFeatureAtPixel(pixel);
        if (!hit) {
            this.calllistenersNoHit(coordinate, pixel);
            return;
        }
        this.callListeners(coordinate, pixel);
    }
    addListener(listener) {
        this.listeners.push(listener);
    }
    callListeners(coordinate, pixel) {
        for (let listener of this.listeners) {
            //console.log("Calling listener" ,listener );
            this.map.forEachFeatureAtPixel(pixel, (feature, layer) => {
                try {
                    listener.onPointerMove(coordinate, feature, layer);
                }
                catch (err) {
                    console.log("MapOnMoveHelper.calllistener", err);
                }
            });
        }
    }
    calllistenersNoHit(coordinate, pixel) {
        for (let listener of this.listeners) {
            listener.setNoHit();
        }
    }
}

class MapStylesHelper {
    constructor(mapc) {
        this.mapc = mapc;
        /**
         * Layers list where onmove is used
         */
        this.layersId = [];
        // when we move the mouse over a feature, we can change its style to
        // highlight it temporarily
        this.highlightStyle = new Style({
            stroke: new Stroke({
                color: [255, 0, 0, 0.6],
                width: 2
            }),
            fill: new Fill({
                color: [255, 0, 0, 0.2]
            }),
            zIndex: 1
        });
        this.map = mapc.map;
    }
    static baseStyleText(text) {
        let st = MapStylesHelper.baseTextStyle;
        if (text) {
            st.text = text;
        }
        let style = new Text(MapStylesHelper.baseTextStyle);
        return style;
    }
    // the style function for the feature overlay returns
    // a text style for point features and the highlight
    // style for other features (polygons in this case)
    styleFunction(feature, resolution) {
        console.log(feature);
        let style;
        let geom = feature.getGeometry();
        if (geom.getType() == 'Point') {
            let text = feature.get('text');
            MapStylesHelper.baseTextStyle.text = text;
            // this is inefficient as it could create new style objects for the
            // same text.
            // A good exercise to see if you understand would be to add caching
            // of this text style
            style = new Style({
                text: MapStylesHelper.baseTextStyle,
                image: new Icon({
                    src: '../assets/ol/marker.svg',
                    scale: 1
                }),
                zIndex: 2
            });
        }
        else {
            style = this.highlightStyle;
        }
        return [style];
    }
    static createStyleIconFactory(src = 'assets/ol/marker1.png', scale = 1, anchor = [1, 1]) {
        let markerStyle = new Style({
            image: new Icon(({
                //color: '#ece60f'
                crossOrigin: 'anonymous',
                src: src,
                scale: scale,
                anchor: anchor,
                anchorXUnits: IconAnchorUnits.FRACTION,
                anchorYUnits: IconAnchorUnits.FRACTION
            }))
        });
        return markerStyle;
    }
}
// we want to create text styles based on properties coming from a feature
// to do this, we need to create a new style for each string that needs to
// be represented.  All the text styles will share the same properties
// except for the actual text itself. The properties can be set up ahead
// of time in an object literal
MapStylesHelper.baseTextStyle = {
    font: 'bold 12px Calibri,sans-serif',
    text: '',
    textAlign: 'center',
    offsetY: -15,
    fill: new Fill({
        color: [0, 0, 0, 1]
    }),
    stroke: new Stroke({
        color: [255, 255, 255, 0.8],
        width: 4
    })
};

class MapTooltipHelper {
    constructor(mapc) {
        this.mapc = mapc;
        this.collection = [];
        /**
         * Layers list where onmove is used
         */
        this.layersId = [];
        // when we move the mouse over a feature, we can change its style to
        // highlight it temporarily
        this.highlightStyle = new Style({
            stroke: new Stroke({
                color: [255, 0, 0, 0.6],
                width: 2
            }),
            fill: new Fill({
                color: [255, 0, 0, 0.2]
            }),
            zIndex: 1
        });
        this.map = mapc.map;
        //mapc.onPointerMove.subscribe(res => this.onPointerMove(res));
        this.featureOverlay = new Vector$1({
            map: mapc.map,
            source: new Vector({
                features: this.collection,
                useSpatialIndex: false // optional, might improve performance
            }),
            style: this.styleFunction.bind(this),
            updateWhileAnimating: true,
            updateWhileInteracting: true // optional, for instant visual feedback
        });
    }
    addLayer(id) {
        this.layersId.push(id);
    }
    /**
     *
     * @param coordinate
     * @param feature
     * @param layer
     */
    onPointerMove(coordinate, feature, layer) {
        if (!this.featureOverlay) {
            return;
        }
        this.featureOverlay.getSource().clear();
        //const layerInfo=layer[mapcte.frlayerinfo_FieldName];
        if (!layer) {
            //console.log("feature with null layer",feature);
            return;
        }
        const haslayer = this.layersId.find(item => item == layer[mapcte.frlayerinfo_FieldName].id);
        if (!haslayer) {
            return;
        }
        this.setFeature(coordinate, feature, layer);
    }
    setNoHit() {
        if (!this.featureOverlay) {
            return;
        }
        this.featureOverlay.getSource().clear();
    }
    setFeature(coordinate, feature, layer) {
        try {
            // check the layer property, if it is not set then it means we
            // are over an OverlayFeature and we can ignore this feature
            if (!layer) {
                return;
            }
            // test the feature's geometry type and compute a reasonable point
            // at which to display the text.
            const geometry = feature.getGeometry();
            let point;
            switch (geometry.getType()) {
                case 'MultiPolygon':
                    const poly = geometry.getPolygons().reduce(function (left, right) {
                        return left.getArea() > right.getArea() ? left : right;
                    });
                    point = poly.getInteriorPoint().getCoordinates();
                    break;
                case 'Polygon':
                    point = geometry.getInteriorPoint().getCoordinates();
                    break;
                default:
                    point = geometry.getClosestPoint(coordinate);
            }
            // create a new feature to display the text
            let textFeature = new Feature({ geometry: new Point(point), text: feature.frlayerinfo.name, id: feature.frlayerinfo.id });
            // and add it to the featureOverlay.  Also add the feature itself
            // so the country gets outlined
            this.featureOverlay.getSource().addFeature(textFeature);
            //this.featureOverlay.getSource().addFeature(feature);
            //featureOverlay.getSource().removeFeature(feature);
        }
        catch (err) {
            console.log(err);
        }
    }
    // the style function for the feature overlay returns
    // a text style for point features and the highlight
    // style for other features (polygons in this case)
    styleFunction(feature, resolution) {
        //console.log(feature);
        let style;
        let geom = feature.getGeometry();
        if (geom.getType() == 'Point') {
            let text = feature.get('text');
            // this is inefficient as it could create new style objects for the
            // same text. would be to add caching
            style = new Style({
                text: MapStylesHelper.baseStyleText(text),
                zIndex: 2
            });
        }
        else {
            style = this.highlightStyle;
        }
        return [style];
    }
}

const materialModules = [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    ScrollingModule
];
class MaterialModule {
}
MaterialModule.ɵmod = ɵɵdefineNgModule({ type: MaterialModule });
MaterialModule.ɵinj = ɵɵdefineInjector({ factory: function MaterialModule_Factory(t) { return new (t || MaterialModule)(); }, providers: [], imports: [[
            materialModules,
            DragDropModule
        ], MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        ScrollingModule, DragDropModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(MaterialModule, { imports: [MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        ScrollingModule, DragDropModule], exports: [MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        ScrollingModule, DragDropModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(MaterialModule, [{
        type: NgModule,
        args: [{
                imports: [
                    materialModules,
                    DragDropModule
                ],
                exports: [
                    materialModules,
                    DragDropModule
                ],
                entryComponents: [],
                declarations: [],
                providers: [],
            }]
    }], null, null); })();

class GmapModule {
}
GmapModule.ɵmod = ɵɵdefineNgModule({ type: GmapModule });
GmapModule.ɵinj = ɵɵdefineInjector({ factory: function GmapModule_Factory(t) { return new (t || GmapModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            MaterialModule,
            BaseComponentsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(GmapModule, { declarations: [OlLayerAddComponent,
        OlMainComponent,
        OlMapBaseComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        BaseComponentsModule], exports: [OlLayerAddComponent,
        OlMainComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(GmapModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MaterialModule,
                    BaseComponentsModule
                ],
                declarations: [
                    OlLayerAddComponent,
                    OlMainComponent,
                    OlMapBaseComponent
                ],
                exports: [
                    OlLayerAddComponent,
                    OlMainComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of gmap
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FrCoordinate, FrLayer, GmapModule, IFrLayer, MAPS_CONFIG_TOKEN, MAPS_CONFIG_TOKEN_DEFAULT, MRectangle, MapMarkerHelper, MapOnMoveHelper, MapRasterHelper, MapStylesHelper, MapTooltipHelper, OlLayerAddComponent, OlMainComponent, OlMapBaseComponent, OlMapOptions, OlMarker, mapcte };
//# sourceMappingURL=gmap.js.map
